'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _util = require('../util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CampaignsPack = function () {
  function CampaignsPack(data) {
    (0, _classCallCheck3.default)(this, CampaignsPack);

    this.data = data;
    this.resetDefault(data);
  }

  (0, _createClass3.default)(CampaignsPack, [{
    key: 'resetDefault',
    value: function resetDefault(data) {
      data.stock = null;
      data.source = 'GIFT';
      !data._allFromStore && (data._allFromStore = false);
    }
  }, {
    key: 'getStock',
    value: function getStock() {
      var _this = this;

      if (this.data.stock === null) {
        return new _promise2.default(function (resolve, reject) {
          return (0, _util.axios)({
            url: '/app/ipos/cart/spvStock?spvId=' + _this.data.spv.id + '&packSource=GIFT&campaignCode=' + _this.data.cid
          }).then(function (_ref) {
            var data = _ref.data;

            _this.data.stock = data;
            _this.data.storeLeft = data.storeCount;
            _this.data.warehouseLeft = data.warehouseCount;
            resolve(data);
          }).catch(function (res) {
            reject(res);
          });
        });
      } else {
        return _promise2.default.resolve(this.data.stock);
      }
    }
  }, {
    key: 'subCount',
    value: function subCount() {
      // let _allFromStore = this.data._allFromStore
      var pack = this.data;
      if (pack.times === 0) {
        return;
      }
      var each = pack.each;
      var next = 0;

      if (each <= pack.warehouseCount) {
        pack.warehouseCount -= each;
      } else {
        next = each - pack.warehouseCount;
        pack.warehouseCount = 0;
      }
      if (pack.storeCount >= next) {
        pack.storeCount -= next;
      } else {
        pack.storeCount = 0;
      }
      // pack.stockCount < 0 && (pack.stockCount = 0)
      pack.times--;
      pack.count -= each;
      // pack.count < 0 && (pack.count = 0)
    }

    // wlog(){
    //   console.log(this.data,'-----------')
    // }

  }, {
    key: 'addCount',
    value: function addCount() {
      var pack = this.data;
      var warehouseCount = pack.warehouseCount,
          storeCount = pack.storeCount,
          each = pack.each,
          storeLeft = pack.storeLeft,
          warehouseLeft = pack.warehouseLeft,
          maximum = pack.maximum;

      var storeAdd = 0;
      var warehouseAdd = 0;
      var _sadd = storeLeft - storeCount;
      var _wadd = warehouseLeft - warehouseCount;
      var addNum = _sadd + _wadd;
      if (addNum < each) {
        return {
          data: false,
          message: '库存不足'
        };
      }
      var addResult = storeCount + warehouseCount + each;
      if (addResult > maximum) {
        return {
          data: false,
          message: '不能添加更多该商品'
        };
      }
      if (pack._allFromStore && _sadd < each) {
        return {
          data: false,
          message: '门店库存不足'
        };
      }

      if (_sadd <= 0) {
        warehouseAdd = each;
      } else {
        if (_sadd < each) {
          storeAdd = _sadd;
          warehouseAdd = each - _sadd;
        } else {
          storeAdd = each;
        }
      }
      if (pack._allFromStore) {
        warehouseAdd = 0;
      }
      pack.storeCount += storeAdd;
      pack.warehouseCount += warehouseAdd;
      pack.times++;
      pack.count += each;

      return {
        data: true,
        message: ''
      };
    }

    // setInWarehousePack(s) {
    //   this.data._allFromStore = s
    // }

  }]);
  return CampaignsPack;
}();

exports.default = CampaignsPack;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/ipos/campaignPack.js
// module id = 1144
// module chunks = 0